<template>
  <div class="container container--fluid">
    <v-app id="inspire">
      <v-data-table :headers="headers" :items="orglistdata" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white" align="center" justify="center">
            <v-toolbar-title>Organization</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="indigo darken-4" dark class="mb-2" v-on="on">New Organization</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row dense>
                      <v-col cols="12" md="12">
                        <v-text-field dense
                          v-model="editedItem.name"
                          label="School name"
                          clearable
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field dense
                          v-model="editedItem.email"
                          label="Email"
                          clearable
                          :rules="[rules.required, rules.email]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field dense
                        v-model="editedItem.phoneno" 
                        label="Phone No" 
                        clearable>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field dense
                          v-model="editedItem.url"
                          label="WebSite URL"
                          clearable
                          hint="For example :: https://www.eduplusschool.com"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field dense
                          v-model="editedItem.country"
                          label="Country"
                          clearable
                          hint="For example :: India"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field dense
                          v-model="editedItem.displayname"
                          label="School Display Name"
                          clearable
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field dense
                          v-model="editedItem.loginattachmentdomain"
                          label="Login Attached Domain Name"
                          clearable
                          hint="For example :: user@eps.com"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-checkbox
                          v-model="editedItem.isactive"
                          label="isActive"
                          color="success"
                          hide-details
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="primary darken-1" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editOrganization(item)" title="Edit">edit</v-icon>
          <v-icon small @click="deleteOrganization(item)" title="Delete">delete</v-icon>
        </template>
        <!-- <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>-->
      </v-data-table>
    </v-app>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      data: {},
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      orglistdata: [],
      dialog: false,
      headers: [
        { text: "School Id", value: "id" },
        { text: "School Name", value: "name", sortable: true },
        { text: "Email", value: "email", sortable: false },
        { text: "Phone No", value: "phoneno", sortable: false },
        { text: "Website URL", value: "url", sortable: false },
        { text: "Country", value: "country", sortable: false },
        { text: "School Display Name", value: "displayname", sortable: false },
        {
          text: "Login Attached Domain Name",
          value: "loginattachmentdomain",
          sortable: false
        },
        { text: "isActive", value: "isactive", sortable: false },
        { text: "Actions", value: "action", sortable: false }
      ],

      editedIndex: -1,
      editedItem: {
        name: "",
        email: "",
        phoneno: "",
        url: "",
        country: "",
        displayname: "",
        loginattachmentdomain: "",
        isactive: "true"
      },
      defaultItem: {
        name: "",
        email: "",
        phoneno: "",
        url: "",
        country: "",
        displayname: "",
        loginattachmentdomain: "",
        isactive: "true"
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Organization" : "Edit Organization";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  mounted() {
    axios
      .post("/roleManagement/addOrganization")
      .then(res => {
        console.log("in addorg:" + res.data.msg);
        if (res.data.msg == "200") {
          this.data = res.data;
          this.orglistdata = res.data.orglist;
          console.log("in if:" + this.orgdata);
        } else {
          console.log("in else:");
        }
      })
      .catch(error => {
        window.console.log(error);
      });
  },
  methods: {
    editOrganization(item) {
      this.editedIndex = this.orglistdata.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteOrganization(item) {
      const index = this.orglistdata.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.orglistdata.splice(index, 1);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.orglistdata[this.editedIndex], this.editedItem);
      } else {
        this.orglistdata.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.mdi-icon-size{
  font-size: 20px;
}
</style>